<div class="op-card hm-card">
<!-- Toolbar -->
<div class="op-toolbar">
  <div class="op-search">
    <emerald-icon class="op-search-ic">search</emerald-icon>
    <input
      type="text"
      [(ngModel)]="filterValue"
      (ngModelChange)="onSearchValueChange($event)"
      placeholder="Search name, position, email, location, status…"
      aria-label="Search candidates"
      autocomplete="off"
    />
    <button
      *ngIf="filterValue?.length && filterValue.length > 0"
      class="op-search-clear"
      (click)="clearInput()"
      aria-label="Clear search"
    >✕</button>
  </div>

  <div class="op-chips" *ngIf="activeFilterCount">
    <span class="op-chip" *ngIf="activeFilters.status">Status: <b>{{ activeFilters.status }}</b></span>
    <span class="op-chip" *ngIf="activeFilters.jobTitle">Position: <b>{{ activeFilters.jobTitle }}</b></span>
    <span class="op-chip" *ngIf="activeFilters.location">Location: <b>{{ activeFilters.location }}</b></span>
    <span class="op-chip" *ngIf="activeFilters.experience">Exp: <b>{{ activeFilters.experience }}</b></span>
  </div>

  <div class="op-spacer"></div>

  <div class="op-filter-slot">
    <button class="op-filterbtn" (click)="toggleFilterPanel()">
      <emerald-icon>filter_list</emerald-icon> Filters
      <span class="op-filter-count" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
    </button>
    <div class="op-filter-backdrop" *ngIf="showFilterPanel" (click)="showFilterPanel = false"></div>
    <div class="op-filter-panel" *ngIf="showFilterPanel">
      <div class="op-fp-head">Filter candidates</div>
      <div class="op-fp-row">
        <label class="op-fp-label">Status</label>
        <select class="op-fp-field" [(ngModel)]="filterDraft.status">
          <option value="">All</option>
          <option *ngFor="let v of facetStatus" [value]="v">{{ v }}</option>
        </select>
      </div>
      <div class="op-fp-row">
        <label class="op-fp-label">Position</label>
        <select class="op-fp-field" [(ngModel)]="filterDraft.jobTitle">
          <option value="">All</option>
          <option *ngFor="let v of facetPosition" [value]="v">{{ v }}</option>
        </select>
      </div>
      <div class="op-fp-row">
        <label class="op-fp-label">Location</label>
        <select class="op-fp-field" [(ngModel)]="filterDraft.location">
          <option value="">All</option>
          <option *ngFor="let v of facetLocation" [value]="v">{{ v }}</option>
        </select>
      </div>
      <div class="op-fp-row">
        <label class="op-fp-label">Experience</label>
        <select class="op-fp-field" [(ngModel)]="filterDraft.experience">
          <option value="">All</option>
          <option *ngFor="let v of facetExperience" [value]="v">{{ v }}</option>
        </select>
      </div>
      <div class="op-fp-actions">
        <button class="op-fp-reset" (click)="resetFilterPanel()">Reset</button>
        <button class="op-fp-apply" (click)="applyFilterPanel()">Apply</button>
      </div>
    </div>
  </div>
</div>

<!-- Table -->
<div class="op-table-wrap" *ngIf="displayCandidatesData?.length; else noDataTemplate">
  <table class="op-table">
    <colgroup>
      <col style="width:12%" /><col style="width:11%" /><col style="width:4%" />
      <col style="width:10%" /><col style="width:9%" /><col style="width:9%" />
      <col style="width:8%" /><col style="width:8%" /><col style="width:5%" />
      <col style="width:7%" /><col style="width:17%" />
    </colgroup>
    <thead>
      <tr>
        <th class="sortable" (click)="sortBy('candidateName')" (mouseenter)="showTip($event, 'Name')" (mouseleave)="hideTip()">Name <span class="op-sort" [ngClass]="sortIndicator('candidateName')"></span></th>
        <th class="sortable" (click)="sortBy('jobTitle')" (mouseenter)="showTip($event, 'Position')" (mouseleave)="hideTip()">Position <span class="op-sort" [ngClass]="sortIndicator('jobTitle')"></span></th>
        <th class="sortable" (click)="sortBy('yearsOfExperience')" (mouseenter)="showTip($event, 'Experience')" (mouseleave)="hideTip()">Exp <span class="op-sort" [ngClass]="sortIndicator('yearsOfExperience')"></span></th>
        <th (mouseenter)="showTip($event, 'Email')" (mouseleave)="hideTip()">Email</th>
        <th class="sortable" (click)="sortBy('location')" (mouseenter)="showTip($event, 'Location')" (mouseleave)="hideTip()">Location <span class="op-sort" [ngClass]="sortIndicator('location')"></span></th>
        <th (mouseenter)="showTip($event, 'Contact Number')" (mouseleave)="hideTip()">Contact</th>
        <th class="sortable" (click)="sortBy('earliestAvailability')" (mouseenter)="showTip($event, 'Available By')" (mouseleave)="hideTip()">Available <span class="op-sort" [ngClass]="sortIndicator('earliestAvailability')"></span></th>
        <th class="sortable" (click)="sortBy('createdDate')" (mouseenter)="showTip($event, 'Received On')" (mouseleave)="hideTip()">Received <span class="op-sort" [ngClass]="sortIndicator('createdDate')"></span></th>
        <th class="sortable" (click)="sortBy('agingDays')" (mouseenter)="showTip($event, 'Profile Aging')" (mouseleave)="hideTip()">Aging <span class="op-sort" [ngClass]="sortIndicator('agingDays')"></span></th>
        <th class="sortable" (click)="sortBy('status')" (mouseenter)="showTip($event, 'Status')" (mouseleave)="hideTip()">Status <span class="op-sort" [ngClass]="sortIndicator('status')"></span></th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of pagedRows; trackBy: trackByIndex">
        <td (mouseenter)="showTip($event, row.candidateName)" (mouseleave)="hideTip()"><span class="op-tip-txt cd-name-main">{{ row.candidateName }}</span></td>
        <td (mouseenter)="showTip($event, row.jobTitle)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.jobTitle }}</span></td>
        <td class="mono">{{ row.yearsOfExperience }}</td>
        <td (mouseenter)="showTip($event, row.emailId)" (mouseleave)="hideTip()"><span class="op-tip-txt muted">{{ row.emailId }}</span></td>
        <td (mouseenter)="showTip($event, row.location)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.location }}</span></td>
        <td (mouseenter)="showTip($event, row.contactNumber)" (mouseleave)="hideTip()"><span class="op-tip-txt mono muted">{{ row.contactNumber }}</span></td>
        <td class="mono muted">{{ row.earliestAvailability | date: dateFormat.Month }}</td>
        <td class="mono muted">{{ row.createdDate | date: dateFormat.Month }}</td>
        <td>
          <span *ngIf="row.agingDays !== null && row.agingDays !== undefined" class="op-age" [ngClass]="agingClass(row.agingDays)">{{ row.agingDays }}d</span>
        </td>
        <td>
          <span class="hm-pill" [ngClass]="statusPillClass(row.status)"><span class="dot"></span>{{ row.status }}</span>
        </td>
        <td class="op-cell-actions">
          <div class="op-actions">
            <button
              *ngIf="row.resumePath"
              class="op-iconbtn"
              title="Download resume"
              (click)="downloadFile(row.resumePath, row.candidateName, 'resume')"
            ><emerald-icon>download</emerald-icon></button>
            <button
              *ngIf="row.additionalDocumentsPath"
              class="op-iconbtn"
              title="Download screening feedback"
              (click)="downloadFile(row.additionalDocumentsPath, row.candidateName, 'attachments')"
            ><emerald-icon>description</emerald-icon></button>
            <a
              *ngIf="row.url"
              class="op-iconbtn"
              title="Open link"
              [href]="row.url | addHttps"
              target="_blank"
            ><emerald-icon>link</emerald-icon></a>
            <app-candidate-feedback
              *ngIf="fieldsVisibility && row.emailId"
              (sendFeedbackStatus)="receiveData($event, row.candidateId)"
              [candidateId]="row.candidateId"
              [fieldsVisibility]="fieldsVisibility"
            ></app-candidate-feedback>
            <button
              class="op-iconbtn"
              title="History"
              (click)="viewHistory(row)"
            ><emerald-icon>history</emerald-icon></button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #noDataTemplate>
  <section class="op-empty" aria-label="Records section">
    <h2 *ngIf="isDataLoaded && displayCandidatesData?.length === 0" class="op-empty-title">No Records Found</h2>
    <img [src]="imageSrc" alt="No records illustration" class="op-empty-img" />
  </section>
</ng-template>

<!-- Pagination footer -->
<div class="op-tfoot" *ngIf="displayCandidatesData?.length">
  <div class="op-info">Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ totalRecords }}</b> candidates</div>
  <div class="op-pager">
    <button class="pg" (click)="prevPage()" [disabled]="currentPageValue === 1" aria-label="Previous page">‹</button>
    <button
      *ngFor="let p of pageWindow; trackBy: trackByIndex"
      class="pg"
      [class.on]="p === currentPageValue"
      [disabled]="p === -1"
      (click)="goToPage(p)"
    >{{ p === -1 ? '…' : p }}</button>
    <button class="pg" (click)="nextPage()" [disabled]="currentPageValue >= totalPages" aria-label="Next page">›</button>
  </div>
  <div class="op-psize">
    <span>Rows</span>
    <select [value]="pageSizeValue" (change)="onPageSizeChange($event)" aria-label="Rows per page">
      <option [value]="5">5</option>
      <option [value]="10">10</option>
      <option [value]="20">20</option>
    </select>
  </div>
</div>
</div>

<!-- Fixed hover tooltip -->
<div class="op-hovertip" *ngIf="hoverTip.show" [style.left.px]="hoverTip.x" [style.top.px]="hoverTip.y">
  {{ hoverTip.text }}
</div>

<!-- History Dialog -->
<ng-template #historyDialog>
  <div class="status-change-dialog">
    <div class="dialog-content">
      <div *ngIf="historySubmissions?.length; else noHistory">
        <div class="duplicate-list">
          <div class="duplicate-row header">
            <div>Job ID</div>
            <div>Job Title</div>
            <div title="Hiring Manager">Hiring Manager</div>
            <div title="Status">Status</div>
            <div title="Feedback">Feedback</div>
            <div title="Vendor">Vendor</div>
            <div title="Submitted Date">Submitted</div>
          </div>
          <div class="duplicate-row" *ngFor="let historySubmission of historySubmissions">
            <div>
              {{ historySubmission.jobId }}
            </div>
            <div [title]="getTooltipText(historySubmission.jobTitle)">
              {{  truncateText(historySubmission.jobTitle, 20) }}
            </div>
            <div [title]="getTooltipText(historySubmission.hiringManager || '')">
              {{ truncateText(historySubmission.hiringManager || '', 20) }}
            </div>
            <div [title]="getTooltipText(historySubmission.status || '')">
              {{ truncateText(historySubmission.status || '', 20) }}
            </div>
            <div [title]="getTooltipText(historySubmission.feedback || '')">
              {{ truncateText(historySubmission.feedback || '', 30) }}
            </div>
            <div [title]="getTooltipText(historySubmission.vendorName || '')">
              {{ truncateText(historySubmission.vendorName || '', 20) }}
            </div>
            <div [title]="getTooltipText((historySubmission.submittedDate | date: 'medium') || '')">
              {{ truncateText((historySubmission.submittedDate | date: 'medium') || '', 20) }}
            </div>
          </div>
        </div>
      </div>
      <ng-template #noHistory>
        <div class="no-history">No Data Available</div>
      </ng-template>
    </div>
    <div class="dialog-actions">
      <emerald-button [label]="'Close'" [type]="'Secondary'" (onClick)="closeHistoryDialog()">
      </emerald-button>
    </div>
  </div>
</ng-template>
